var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMotivation5B1Ea3Ae(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 306,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0_15777_45132)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M18.236 221.076c2.037 12.525 14.472 70.785 59.895 83.178 34.395 9.371 130.876-22.786 185.897-6.609 110.668 32.532 130.94-54.81 124.754-78.4-4.307-16.446-9.625-32.94-9.768-50.111-.143-17.991 6.149-35.628 6.836-53.72 1.736-45.782-30.431-90.729-74.325-103.857C292.74 5.937 277.384.207 257.774.037 217.981-.302 123.553.037 77.041 67.7c-8.313 12.097-20.383 21.135-29.633 32.511-12.42 15.235-20.605 33.612-25.585 52.63-5.826 22.167-7.254 45.666-3.587 68.235z",
    fill: "rgb(56 120 244 )",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.935 270.547a35.676 35.676 0 007.8 2.846 174.854 174.854 0 0017.901 3.81c5.54.884 11.255 1.979 16.833 1.926l38.681-.38 13.927-.138c4.482-.042 9.028-.095 13.345-1.312 4.318-1.217 8.467-3.757 10.584-7.689.559-.896.833-1.94.788-2.995-.249-2.275-2.678-3.572-4.831-4.334-9.88-3.482-20.452-4.053-30.829-4.387-5.17-.169-10.345.355-15.53.371-5.62 0-11.24-.117-16.859.106-9.859.397-19.643 1.915-29.485 2.54-8.292.529-16.721.444-24.727 2.645-.995.276-2.117.731-2.387 1.726-.238.904.376 1.799 1.021 2.471a15.358 15.358 0 003.768 2.794z",
    fill: "url(#prefix__paint0_linear_15777_45132)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M254.329 32.2s17.991 8.063 25.447 25.753c7.456 17.69 7.636 21.098 7.636 21.098s14.7-25.754 37.353-21.41c22.653 4.344 26.061 17.065 26.061 17.065S310.78 88.993 299.62 88.993h-11.16v113.07h-8.79l3.302-113.705s-18.102-.312-36.247-24.822c-18.145-24.51-22.489-28.236-32.702-27.934 0 0 21.696-9.61 40.306-3.403z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.655 274.78c-1.212.159-2.45.18-3.656.418-3.98.783-7.705 2.487-11.594 3.598-5.43 1.551-11.112 1.916-16.7 2.762-1.286.196-2.89.768-2.916 2.069a2.484 2.484 0 001.058 1.799c1.8 1.546 4.133 2.308 6.419 2.948a102.301 102.301 0 0027.405 3.804c6.73 0 13.911-.814 19.097-5.106 1.963-1.624 3.641-3.963 3.408-6.503.037.418 29.104-1.635 31.633-2.043 6.207-1.01 12.345-2.894 17.653-6.265a1.676 1.676 0 00.862-.958c.127-.598-.407-1.132-.942-1.439-1.407-.815-3.085-.984-4.704-1.106a136.399 136.399 0 00-21.42.064c-2.646.216-5.339.529-8.006.799a910.922 910.922 0 01-19.235 1.857c-3.112.27-6.578.122-9.626.783-2.338.529-4.72 1.439-7.032 2.164-.557.166-1.127.285-1.704.355z",
    fill: "url(#prefix__paint1_linear_15777_45132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.308 205.646l-1.291 63.504h-8.615l-2.482-50.471-5.413 50.471-9.869 1.651-2.259-67.24 29.929 2.085z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.308 205.646l-1.291 63.504h-8.615l-2.482-50.471-5.413 50.471-9.869 1.651-2.259-67.24 29.929 2.085z",
    fill: "url(#prefix__paint2_linear_15777_45132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.538 268.16v-58.863l-8.159-5.736 2.752 65.589 5.407-.99z",
    fill: "url(#prefix__paint3_linear_15777_45132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.728 164.07s-.063.058-.185.153v.027c-1.842 1.587-16.298 14.038-18.468 13.308-1.862-.614-6.768-3.535-8.62-4.672l-.725-.44v-17.499l9.023 10.827 16.033-9.456 2.942 7.752z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.544 164.223v.027c-1.841 1.587-16.298 14.038-18.467 13.308-1.863-.614-6.768-3.535-8.62-4.672-.09-.702-.12-1.41-.09-2.117.026-1.55-.529-5.292 1.841-4.397 1.932.751 3.329 3.243 5.223 4.191.614.545 1.373.9 2.185 1.021 1.323.079 2.376-.99 3.292-1.926a39.664 39.664 0 0111.176-8.043c.185-.106.395-.16.608-.159.236.064.444.204.593.397.751.772 1.508 1.577 2.259 2.37z",
    fill: "url(#prefix__paint4_linear_15777_45132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.76 149.471a75.993 75.993 0 00-6.71 3.788c-4.609 2.953-3.778 4.318-2.931 9.409a200.077 200.077 0 012.698 32.924c0 2.598-.174 5.45.561 7.969.476 1.645 1.588 3.016 1.704 4.762 7.107.979 23.357 4.636 28.225-2.646 4.652-6.984-3.704-31.807-2.175-42.819 1.53-11.012-12.699-12.266-12.699-12.266l-8.673-1.121z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.546 200.37l-12.88 8.689-2.117-2.688s-2.032-6.832-1.72-13.758c.313-6.927-.031-4.451-.031-4.451l18.123 11.478-1.375.73z",
    fill: "url(#prefix__paint5_linear_15777_45132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.947 138.729c.02.732-.021 1.465-.122 2.19a13.5 13.5 0 01-1.767 4.281c-.211.46-.525.865-.916 1.186-.746.529-1.757.359-2.646.217a1.265 1.265 0 00-.635 0c-.529.19-.571.878-.529 1.423l.132 2.524c.057.346-.002.702-.169 1.011-.173.209-.405.36-.667.434a5.41 5.41 0 01-5.434-1.233 3.637 3.637 0 01-.852-1.149 4.628 4.628 0 01-.317-1.312c-.302-2.413-.053-4.858-.223-7.286-.137-2.016-.566-4.054-.18-6.033a6.697 6.697 0 013.895-4.926c2.011-.815 4.302-.45 6.387.143 1.006.284 1.997.619 2.968 1.005a1.99 1.99 0 011.154.841c.381.773-.032 1.9-.048 2.731-.053 1.323-.026 2.64-.031 3.953z",
    fill: "#BE6F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.962 128.791c.217.492.529.921.794 1.397.285.462.381 1.015.27 1.545a2.196 2.196 0 01-.767 1.027c-1.667 1.37-3.974 1.651-6.128 1.54a9.596 9.596 0 00-1.841 0 2.557 2.557 0 00-1.625.783c-.635.735-.598 1.81-.799 2.762a.252.252 0 01-.074.159.218.218 0 01-.116.037c-.683.09-1.323-.72-1.958-.45a1.06 1.06 0 00-.529.868 2.42 2.42 0 00.185 1.238c.083.15.135.316.153.487a1.102 1.102 0 01-.079.339l-.439 1.195a1.843 1.843 0 01-.757 1.101c-.529.259-1.143-.026-1.646-.323a1.968 1.968 0 01-1.201-1.587c-.677-2.979-.73-6.059-.725-9.112a5.201 5.201 0 01.296-2.117c.583-1.349 2.144-1.952 3.578-2.265 2.645-.566 5.365-.576 8.064-.587.847-.033 1.695.027 2.529.18a3.842 3.842 0 012.17 1.222",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.003 148.312s-1.969 1.381-1.916 2.878c.053 1.498 10.731 31.596 10.731 31.596s.244-28.802 0-30.162a21.746 21.746 0 00-1.444-3.773s-4.244 3.096-7.371-.539z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.507 151.037l-.714 2.328 1.201 1.006.577 16.34 4.249 12.075.101-12.282-3.646-16.213 1.333-2.286-1.757-.968h-1.344z",
    fill: "#212642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.848 161.953a5.888 5.888 0 01.936-4.894l2.202-3.054c.375-.529.772-1.058 1.132-1.587.244-.36.355-.72.773-.937.272-.12.565-.188.862-.201l1.519-.158a.99.99 0 01.376 0 .666.666 0 01.412.666 1.997 1.997 0 01-.259.783 7.562 7.562 0 012.72-1.058.849.849 0 01.413 0 .741.741 0 01.338.333c.394.756.628 1.585.688 2.435.127.926.259 1.846.36 2.778a2.31 2.31 0 010 .714c-.065.252-.18.487-.339.693a4.784 4.784 0 01-2.46 1.783c-.61.165-1.231.287-1.858.366-1.735.308-3.397.94-4.9 1.862a5.298 5.298 0 01-1.174.609 1.38 1.38 0 01-1.26-.191 1.697 1.697 0 01-.481-.942z",
    fill: "#BE6F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.408 193.528a28.16 28.16 0 01-4.265 4.329c-.322.264-.65.529-.984.772-.35.316-.787.521-1.254.587a2.452 2.452 0 01-.926-.222 201.909 201.909 0 01-18.261-8.186c-2.487-1.28-5.223-2.958-5.752-5.699a9.065 9.065 0 01.069-2.878 82.92 82.92 0 015.408-20.241c.751-1.841 1.688-5.381 3.651-6.572l.227-.121.281-.133c2.646-.957 4.947 1.688 5.672 3.927 1.027 3.175.53 6.635-.296 9.863-.825 3.228-1.984 6.392-2.27 9.721-.075.455-.029.922.132 1.354.251.42.602.771 1.022 1.022 5.856 4.162 11.705 8.321 17.546 12.477z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.861 142.427l-.577-1.058c-.338.191-8.466 4.583-14.578 9.985-9.466 8.398-16.959 19.108-19.579 27.956-4.011 13.668-16.933 19.256-18.218 19.785-2.17.471-24.003 5.783-28.11 27.129l-.835 4.318c-3.26 17.182-8.197 43.132-14.446 47.037a.043.043 0 01-.016.004.044.044 0 01-.016-.004 1.969 1.969 0 01-1.667.307l-.275-.079h-.053a3.011 3.011 0 000-2.837 3.084 3.084 0 00-1.508-1.376 5.741 5.741 0 00-2.318-.407l-9.958-.079c-4.853-.043-9.864-.074-14.817.804a3.534 3.534 0 00-2.45 1.587 2.264 2.264 0 00-.074 1.953l.307.736.783.211c1.519.408 3.043.762 4.562 1.059l.222.052a88.843 88.843 0 0018.16 1.831c2.251 0 4.525-.077 6.821-.232a5.371 5.371 0 004.022-.768c6.91-4.323 11.308-24.87 15.949-49.211l.825-4.308c3.868-20.134 24.77-24.378 25.654-24.552l.275-.08c.629-.233 15.636-6.048 20.319-21.976 2.45-8.297 9.567-18.414 18.595-26.41 5.821-5.148 13.874-9.525 13.948-9.556l-.947-1.821zM64.712 276.441l9.948.08c.2-.003.4.007.598.031a3.756 3.756 0 01-1.312 0l-.037.307-.143 1.18a87.678 87.678 0 01-16.288-1.09 62.595 62.595 0 01-2.069-.365c3.096-.217 6.218-.164 9.303-.143z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.861 142.427c-2.545 1.445-8.609 5.07-13.403 9.324-9.451 8.387-16.96 19.097-19.579 27.955-4.022 13.658-16.933 19.256-18.219 19.775-2.169.471-24.013 5.784-28.108 27.13l-.826 4.318c-1.767 9.302-3.524 18.626-5.921 27.791a95.147 95.147 0 01-3.778 11.901c-.969 2.37-2.16 5.408-4.281 7.006-1.64 1.238-4.498 1.545-6.504 1.852-2.451.364-4.93.515-7.408.45a88.598 88.598 0 01-13.821-1.657c-1.757-.317-3.556-.666-5.096-1.587a1.087 1.087 0 00-.857-.238c-.477.158 0 1.132.1 1.413l.318.735.772.201c.937.244 1.873.487 2.81.693l.222.053a88.843 88.843 0 0018.161 1.831c2.25 0 4.524-.077 6.82-.233 1.39.286 2.836.01 4.022-.767 6.911-4.323 11.308-24.87 15.95-49.211l.825-4.308c3.868-20.134 24.769-24.378 25.653-24.553l.275-.079c.63-.233 15.637-6.048 20.32-21.976 2.45-8.297 9.567-18.414 18.594-26.41 5.821-5.149 13.875-9.525 13.949-9.556l-.99-1.853zM75.697 276.96l-.164 1.487a86.206 86.206 0 01-18.372-1.455h.317c3-.185 6.033-.164 8.996-.143l7.445.053h2.514c.254 0 .444 0 .598.032-.44.086-.891.095-1.334.026z",
    fill: "url(#prefix__paint6_linear_15777_45132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.999 284.151a90.077 90.077 0 01-25.93-3.81 1.658 1.658 0 11.959-3.175 86.868 86.868 0 0029.802 3.535 53.106 53.106 0 005.572-.561c.402-.063.799-.137 1.196-.217a1.27 1.27 0 00.978-.487 45.432 45.432 0 001.91-2.402l.44-.598c.593-.836 1.222-1.736 2.185-2.09.963-.355 2.413-.069 2.678 1.058.048.208.084.418.106.63a5.587 5.587 0 01-1.28 4.122c-1.514 1.773-3.779 2.461-5.583 2.857a49.55 49.55 0 01-8.022 1.001c-1.68.088-3.35.134-5.011.137z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.999 284.167a90.112 90.112 0 01-25.93-3.81 1.658 1.658 0 11.959-3.175 86.892 86.892 0 0029.802 3.535 45.506 45.506 0 007.493-.915c1.693-.371 3.65-.969 4.38-2.694a1.138 1.138 0 00-.052-1.227 2.6 2.6 0 00-.429-.276.526.526 0 01-.264-.412c0-.186.18-.318.338-.408a2.93 2.93 0 012.117-.27c.894.217 1.397.619 1.492 1.535a5.572 5.572 0 01-1.28 4.122c-1.514 1.773-3.778 2.461-5.583 2.857a48.232 48.232 0 01-8.022 1c-1.686.089-3.36.135-5.021.138z",
    fill: "url(#prefix__paint7_linear_15777_45132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.466 282.05c-.001.141-.02.282-.053.418-.084.322-.27.608-.53.815a8.544 8.544 0 01-2.328 1.456 11.13 11.13 0 01-3.566.661c-5.482.386-11.266.794-17.129.794-7.514 0-15.15-.672-22.447-2.911a1.188 1.188 0 01-.306-.132 1.651 1.651 0 01-.754-1.852 1.654 1.654 0 012.108-1.148c12.382 3.799 26.125 2.831 38.316 1.974a8.548 8.548 0 002.567-.434c.51-.222.98-.522 1.397-.889a1.659 1.659 0 012.485.365c.172.268.262.581.261.899l-.021-.016z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.416 282.469c-.084.321-.27.607-.53.814a8.544 8.544 0 01-2.328 1.456 11.13 11.13 0 01-3.566.661c-5.482.386-11.266.794-17.129.794-7.514 0-15.15-.672-22.447-2.911a1.188 1.188 0 01-.307-.132l.032-.116a1.622 1.622 0 011.556-1.117c.18-.005.359.022.529.08 12.388 3.799 26.14 2.831 38.332 1.973a8.549 8.549 0 002.566-.434 5.326 5.326 0 001.387-.889 1.696 1.696 0 011.905-.179z",
    fill: "url(#prefix__paint8_linear_15777_45132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.784 268.351l-63.916-1.551-11.79-60.784h88.12l-12.414 62.335z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.784 268.351l-63.916-1.551-11.79-60.784h88.12l-12.414 62.335z",
    fill: "url(#prefix__paint9_linear_15777_45132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.786 268.351l-51.502-1.249-9.514-42.888h69.552l-8.536 44.137zM286.57 130.146a13.056 13.056 0 00-3.624 2.45 5.29 5.29 0 00-1.588 3.953c.138 1.772 1.413 3.238 2.752 4.407 1.54 1.344 3.402 2.757 3.524 4.795 1.101-.81 2.09-1.768 3.223-2.54 1.984-1.35 4.312-2.075 6.492-3.075 2.18-1 4.334-2.402 5.371-4.561.557-1.363.877-2.811.947-4.281.226-1.577.269-3.175.127-4.762a6.937 6.937 0 00-1.973-4.234 9.492 9.492 0 00-2.8-1.624 9.136 9.136 0 00-3.085-.863c-2.264-.1-4.762 1.794-5.572 3.906-.444 1.19-.232 2.545-.677 3.704-.524 1.428-1.873 2.1-3.117 2.725z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.307 202.063a3.935 3.935 0 00-1.265.196 1.125 1.125 0 00-.757.947c.016.21.085.413.2.589.114.177.271.322.456.422.35.228.757.365 1.106.593.297.25.616.473.953.666a2.92 2.92 0 001.836-.068 23.999 23.999 0 018.376-.53c.273.037.548.037.821 0 .82-.127 1.37-.91 1.677-1.677.656-1.662.624-3.508.482-5.292a1.17 1.17 0 00-.143-.566 1.012 1.012 0 00-.413-.328c-2.646-1.312-4.106 1.312-6.059 2.593a14.927 14.927 0 01-7.27 2.455z",
    fill: "#8A4621"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.457 163.033s.667 9.932-8.207 12.927c-8.874 2.995-24.775.529-24.775.529s-6.408 12.266-12.943 18.103l-4.196 4.143s-2.736.857-4.609-2c0 0 12.419-24.648 14.033-26.49a14.817 14.817 0 017.249-4.762 19740.35 19740.35 0 0017.706-5.572l15.742 3.122zM242.223 130.49l9.509 20.176 17.557-.121-.143-1.519-16.15-.18-8.942-19.092-1.831.736z",
    fill: "#473F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.712 117.451c-.334.53-1.006.879-1.222 1.482-.26.736.248 1.487.529 2.222.365 1.016.248 2.159.603 3.175.063.223.187.423.36.577.159.108.339.18.529.212a7.837 7.837 0 002.307.137.645.645 0 01.45.059c.115.099.187.24.201.391a12.345 12.345 0 01-.09 5.879c-.164.63-.349 1.402.122 1.863.166.151.371.253.592.296 1.466.36 2.879-.725 3.863-1.863a17.152 17.152 0 002.27-3.328c.189-.328.32-.686.386-1.058a3.78 3.78 0 00-.201-1.45 24.23 24.23 0 01-.756-4.884c-.111-2.117.042-4.318-.768-6.276a3.282 3.282 0 00-1.28-1.646 4.12 4.12 0 00-2.281-.365c-1.534.058-3.222.265-4.27 1.397-.307.323-.937 2.498-1.344 3.18z",
    fill: "#8A4621"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.479 127.622s-6.35 3.275-8.228 5.82c-1.879 2.546-5.043 4.467-3.837 9.329 1.207 4.863-.269 12.282-.269 12.282s2.746 8.647 9.487 10.837c6.742 2.191 4.906 1.487 4.906 1.487s3.593-16.023 4.989-20.489c1.397-4.466-.878-19.981-7.048-19.266z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.752 114.049a4.32 4.32 0 001.397 2.709c.746.704 1.677 1.18 2.45 1.852.772.672 1.402 1.662 1.228 2.646a1.37 1.37 0 011.677.529 1.1 1.1 0 01-.18 1.159 1.392 1.392 0 01-1.106.46c.8.323 1.487.876 1.974 1.588.529.799.804 1.757 1.296 2.587.529.926 1.445 1.482 2.265 2.117.408.268.744.631.979 1.058.182.638.403 1.263.661 1.874.477.846 1.244 1.492 1.81 2.28.741 1.058 1.503 3.027 1.434 4.297a7.41 7.41 0 010-1.365c.159-.275.312-.529.455-.831a7.375 7.375 0 00.566-1.556c.302-1.243.096-2.471.101-3.704 0-2.646 2.513-7.683.497-9.964-.698-.783-1.751-1.143-2.555-1.815-1.784-1.471-2.038-4.069-3.175-6.09a7.674 7.674 0 00-4.673-3.652c-2.651-.703-7.445.122-7.101 3.821z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.038 135.956s-3.995 10.805-4.762 11.594c-.768.788 7.694 5.566 7.694 5.566s5.529-10.503 5.291-15.059c-.238-4.556-5.106-6.393-8.223-2.101z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.95 151.651s-.296 3.481-4.561 3.418c-4.265-.064-18.981-.265-18.981-.265-1.291-.666-3.064-.777-4.027-1.862-.46-.529-.698-1.207-1.143-1.741a3.889 3.889 0 00-2.312-1.233 11.828 11.828 0 00-2.646-.069 1.106 1.106 0 010-1.444 2.59 2.59 0 011.381-.747 8.52 8.52 0 016.43.911 7.365 7.365 0 001.815.957c.476.1.965.129 1.449.085 5.472-.265 10.869-1.429 16.341-1.672a9.478 9.478 0 013.804.397 4.483 4.483 0 012.45 3.265z",
    fill: "#8A4621"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.919 177.315h-24.531c-.579 0-1.048.469-1.048 1.047v4.271c0 .578.469 1.047 1.048 1.047h24.531c.579 0 1.048-.469 1.048-1.047v-4.271c0-.578-.469-1.047-1.048-1.047z",
    fill: "#473F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.561 183.675h-4.503l-2.249 20.822h4.503l2.249-20.822zM301.467 183.675h-4.498l2.979 20.822h4.498l-2.979-20.822zM311.079 142.39h-4.037l-9.112 35.078h4.037l9.112-35.078z",
    fill: "#473F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.44 202.069H222.117v17.811H328.44v-17.811z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.44 202.069H222.117v17.811H328.44v-17.811z",
    fill: "url(#prefix__paint10_linear_15777_45132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.44 202.069H222.117v14.615H328.44v-14.615z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.922 152.81h-2.688v49.259h2.688V152.81z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.126 192.988a6.794 6.794 0 10.001-13.589 6.794 6.794 0 00-.001 13.589z",
    fill: "#F4BD5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.29 152.81h-2.688v49.259h2.688V152.81z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.402 269.15l.466 4.677 2.947.529 1.323-1.164 2.249 1.784h8.842s2.249-3.879-2.645-5.197l-4.885-1.317-8.297.688zM107.137 269.15l.465 4.677 2.948.529 1.317-1.164 2.255 1.784h8.836s2.249-3.879-2.645-5.197l-4.884-1.317-8.292.688z",
    fill: "#212642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.922 218.679l3.958-3.207 2.794 53.006-4.27.672-2.482-50.471z",
    fill: "url(#prefix__paint11_linear_15777_45132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.143 197.857c-.322.264-.65.529-.984.772-.35.316-.787.521-1.254.587a2.471 2.471 0 01-.926-.222 201.909 201.909 0 01-18.261-8.186c-2.487-1.28-5.223-2.958-5.752-5.699a9.065 9.065 0 01.069-2.878 82.92 82.92 0 015.408-20.241c.751-1.841 1.688-5.381 3.651-6.572l.227-.121.281-.133a5.924 5.924 0 015.672 3.927s-9.408 19.261-8.995 22.161c.413 2.899 20.155 12.329 20.155 12.329l.709 4.276z",
    fill: "url(#prefix__paint12_linear_15777_45132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.83 195.142c.517.128.999.368 1.412.704a1.387 1.387 0 01.45 1.428 5.177 5.177 0 01-.529.842c-.259.46-.291 1.016-.529 1.487a3.344 3.344 0 01-1.969 1.428c-2.354.847-5.222.969-7.122-.661-1.386-1.185-4.154-6.064-1.101-6.8 1.133-.27 2.731.244 3.858.402a34.47 34.47 0 015.53 1.17zM161.901 153.99a1.47 1.47 0 00.736-1.26 1.176 1.176 0 00-.17-.46 2.005 2.005 0 00-2.534-.773 3.905 3.905 0 00-1.387 1.455 16.853 16.853 0 00-1.545 2.323c-.312.709.275.471.789.276 1.344-.503 2.931-.71 4.111-1.561z",
    fill: "#BE6F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.528 276.33c6.748.095 13.493.129 20.235.101a1.815 1.815 0 00-1.106-1.318 5.548 5.548 0 00-2.36-.338c-2.55.021-5.098.165-7.641.433a45.156 45.156 0 01-4.874.381c-1.513 0-3.016-.211-4.524-.312a52.414 52.414 0 00-3.519-.095c-.476 0-2.587-.249-2.381.392.243.751 2.17.619 2.725.656a76.17 76.17 0 003.445.1z",
    fill: "url(#prefix__paint13_linear_15777_45132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.775 150.666h-37.697v4.281h37.697v-4.281z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.234 96.613a5.503 5.503 0 100-11.006 5.503 5.503 0 000 11.006zM275.277 99.518a5.503 5.503 0 100-11.006 5.503 5.503 0 000 11.006zM191.468 126.632a3.19 3.19 0 100-6.382 3.19 3.19 0 000 6.382zM180.398 140.21a3.19 3.19 0 100-6.381 3.19 3.19 0 000 6.381z",
    fill: "#F4BD5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.399 139.274a2.254 2.254 0 100-4.509 2.254 2.254 0 000 4.509z",
    fill: "#D39D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.085 135.66a3.19 3.19 0 100-6.382 3.19 3.19 0 000 6.382zM198.531 135.66a3.19 3.19 0 10-.001-6.381 3.19 3.19 0 00.001 6.381zM204.015 117.869a3.19 3.19 0 100-6.381 3.19 3.19 0 000 6.381zM216.734 124.251a3.191 3.191 0 100-6.383 3.191 3.191 0 000 6.383zM212.245 100.391a3.19 3.19 0 10.002-6.38 3.19 3.19 0 00-.002 6.38zM321.646 116.091a6.794 6.794 0 100-13.589 6.794 6.794 0 000 13.589z",
    fill: "#F4BD5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.645 114.61a5.313 5.313 0 10-.001-10.625 5.313 5.313 0 00.001 10.625z",
    fill: "#D39D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.677 186.194a6.794 6.794 0 10.001-13.589 6.794 6.794 0 00-.001 13.589zM246.728 122.886a6.794 6.794 0 10-.001-13.589 6.794 6.794 0 00.001 13.589zM224.556 155.106a6.794 6.794 0 100-13.589 6.794 6.794 0 000 13.589z",
    fill: "#F4BD5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.556 155.106a6.794 6.794 0 100-13.589 6.794 6.794 0 000 13.589z",
    fill: "#F4BD5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.555 153.116a4.804 4.804 0 100-9.608 4.804 4.804 0 000 9.608zM246.727 120.896a4.804 4.804 0 100-9.609 4.804 4.804 0 000 9.609zM275.273 97.91a3.895 3.895 0 100-7.79 3.895 3.895 0 000 7.79zM236.234 95.005a3.895 3.895 0 100-7.79 3.895 3.895 0 000 7.79zM232.128 190.803a4.609 4.609 0 100-9.218 4.609 4.609 0 000 9.218z",
    fill: "#D39D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.061 112.959c-.27 1.751-.503 3.508-.709 5.291M248.098 115.022a1.641 1.641 0 00-1.418-1.28.837.837 0 00-.641.169.916.916 0 00-.227.445 2.08 2.08 0 00-.032.746c.011.122.051.24.117.344.18.243.529.249.814.344a1.22 1.22 0 01.81 1.116.69.69 0 01-.063.307.783.783 0 01-.233.222 1.72 1.72 0 01-1.117.387.805.805 0 01-.756-.778",
    stroke: "#F4BD5C",
    strokeWidth: 0.55,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.571 91.602c-.23 1.492-.429 2.986-.598 4.482M276.464 93.359a1.399 1.399 0 00-1.207-1.09.718.718 0 00-.529.143.751.751 0 00-.196.38 1.718 1.718 0 00-.026.636.584.584 0 00.1.29c.148.207.445.212.688.292a1.057 1.057 0 01.688.947.528.528 0 01-.053.26.61.61 0 01-.196.19 1.443 1.443 0 01-.947.328.67.67 0 01-.645-.662",
    stroke: "#F4BD5C",
    strokeWidth: 0.466,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.971 106.461c-.27 1.751-.529 3.513-.709 5.291M323.031 108.53a1.639 1.639 0 00-1.418-1.281.832.832 0 00-.64.164.94.94 0 00-.227.45 1.952 1.952 0 00-.032.746.728.728 0 00.116.344c.18.244.529.249.815.344.232.082.434.233.578.433.145.199.226.437.232.684a.595.595 0 01-.069.301.73.73 0 01-.228.228c-.316.254-.71.391-1.116.386a.813.813 0 01-.757-.778",
    stroke: "#F4BD5C",
    strokeWidth: 0.55,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.676 184.712a5.313 5.313 0 10.001-10.625 5.313 5.313 0 00-.001 10.625z",
    fill: "#D39D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.025 176.563a152.195 152.195 0 00-.709 5.292M331.063 178.632a1.639 1.639 0 00-.507-.868 1.64 1.64 0 00-.917-.412.712.712 0 00-.862.614c-.058.244-.07.497-.037.746.012.122.054.24.121.344.18.243.53.248.815.344a1.224 1.224 0 01.81 1.116.618.618 0 01-.069.307.827.827 0 01-.227.222 1.739 1.739 0 01-1.117.387.796.796 0 01-.757-.778M236.584 88.274c-.27 1.751-.529 3.513-.709 5.291",
    stroke: "#F4BD5C",
    strokeWidth: 0.55,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.621 90.337a1.63 1.63 0 00-1.418-1.275.825.825 0 00-.64.164.908.908 0 00-.228.45 1.952 1.952 0 00-.031.746.706.706 0 00.116.344c.18.243.529.249.815.344a1.221 1.221 0 01.81 1.111.608.608 0 01-.069.302.724.724 0 01-.228.227 1.777 1.777 0 01-1.116.387.8.8 0 01-.757-.784M224.904 145.475c-.269 1.752-.529 3.514-.709 5.292",
    stroke: "#F4BD5C",
    strokeWidth: 0.55,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.942 147.544a1.639 1.639 0 00-.507-.868 1.64 1.64 0 00-.917-.412.823.823 0 00-.635.164.895.895 0 00-.227.45c-.058.244-.07.497-.037.746a.79.79 0 00.121.344c.18.243.53.248.815.344a1.213 1.213 0 01.81 1.116.589.589 0 01-.069.302.78.78 0 01-.227.227 1.745 1.745 0 01-1.117.387.8.8 0 01-.757-.778M233.412 183.559c-.27 1.751-.503 3.508-.709 5.291",
    stroke: "#F4BD5C",
    strokeWidth: 0.55,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.449 185.622a1.639 1.639 0 00-1.418-1.28.806.806 0 00-.635.169.842.842 0 00-.227.445c-.06.244-.073.497-.037.746.01.122.05.24.116.344.18.243.529.248.815.344.231.083.432.234.576.434.145.199.226.436.234.682a.678.678 0 01-.064.307.707.707 0 01-.233.222c-.315.257-.71.394-1.116.387a.808.808 0 01-.757-.778",
    stroke: "#F4BD5C",
    strokeWidth: 0.55,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear_15777_45132",
    x1: 280.047,
    y1: 197.994,
    x2: 266.676,
    y2: 362.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint1_linear_15777_45132",
    x1: 108.43,
    y1: 218.837,
    x2: 91.032,
    y2: 367.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint2_linear_15777_45132",
    x1: 91.161,
    y1: 220.795,
    x2: 197.277,
    y2: 283.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint3_linear_15777_45132",
    x1: 132.461,
    y1: 215.287,
    x2: 75.767,
    y2: 263.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint4_linear_15777_45132",
    x1: 149.771,
    y1: 186.411,
    x2: 135.616,
    y2: 142.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint5_linear_15777_45132",
    x1: 117.482,
    y1: 183.94,
    x2: 96.49,
    y2: 228.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint6_linear_15777_45132",
    x1: 156.759,
    y1: 256.101,
    x2: 61.505,
    y2: 156.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint7_linear_15777_45132",
    x1: 67.432,
    y1: 268.393,
    x2: 67.231,
    y2: 310.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint8_linear_15777_45132",
    x1: 68.514,
    y1: 295.814,
    x2: 67.889,
    y2: 263.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint9_linear_15777_45132",
    x1: 272.463,
    y1: 179.865,
    x2: 297.593,
    y2: 320.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint10_linear_15777_45132",
    x1: 274.731,
    y1: 175.849,
    x2: 275.975,
    y2: 255.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint11_linear_15777_45132",
    x1: 112.371,
    y1: 239.438,
    x2: 151.465,
    y2: 248.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint12_linear_15777_45132",
    x1: 140.13,
    y1: 161.324,
    x2: 62.973,
    y2: 202.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint13_linear_15777_45132",
    x1: 64.285,
    y1: 268.88,
    x2: 64.984,
    y2: 287.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0_15777_45132"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h406v306H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotivation5B1Ea3Ae);
export default __webpack_public_path__ + "static/media/motivation.5b1ea3ae.c316e477ac0297b70efe7230adc36178.svg";
export { ForwardRef as ReactComponent };